import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function MobileApp(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Erweiterungen"
      title="Mobile App – Buchhaltung von unterwegs"
      subtitle="Mit der Saldify App für iOS und Android haben Sie Ihre Buchhaltung immer dabei. Belege scannen, Rechnungen erstellen, Überblick behalten."
      heroImage="/screenshots/app-belege.webp"
      heroImageAlt="Belegerfassung in Saldify – auch unterwegs per App"
      features={[
        {
          title: 'Belege scannen',
          description: 'Fotografieren Sie Belege unterwegs. Die KI erkennt alle relevanten Daten automatisch.',
        },
        {
          title: 'Rechnungen erstellen',
          description: 'Erstellen und versenden Sie Rechnungen direkt vom Smartphone.',
        },
        {
          title: 'Dashboard unterwegs',
          description: 'Behalten Sie Umsatz, offene Rechnungen und Cashflow im Blick.',
        },
        {
          title: 'Offline-Modus',
          description: 'Arbeiten Sie auch ohne Internetverbindung. Daten werden automatisch synchronisiert.',
        },
        {
          title: 'Push-Benachrichtigungen',
          description: 'Erhalten Sie Benachrichtigungen bei Zahlungseingängen oder überfälligen Rechnungen.',
        },
        {
          title: 'Zeiterfassung',
          description: 'Erfassen Sie Arbeitszeiten für Projekte und Kunden direkt in der App.',
        },
      ]}
      sections={[
        {
          title: 'Belege sofort erfassen',
          description: 'Kein Zettelchaos mehr! Fotografieren Sie Belege direkt nach dem Erhalt und die KI-Erkennung erledigt den Rest.',
          bullets: [
            'Kamera öffnen und fotografieren',
            'Automatische Texterkennung (OCR)',
            'Kategorisierung per KI',
            'Beleg direkt verbucht',
          ],
          imageSide: 'right',
        },
        {
          title: 'Rechnungen von überall',
          description: 'Erstellen Sie nach einem Kundentermin sofort die Rechnung – noch bevor Sie das Büro erreichen.',
          bullets: [
            'Alle Kundendaten verfügbar',
            'Produkte und Preise auswählen',
            'Direkt per E-Mail versenden',
            'Unterschrift digital erfassen',
          ],
          imageSide: 'left',
        },
        {
          title: 'Immer informiert',
          description: 'Push-Benachrichtigungen informieren Sie über wichtige Ereignisse: Zahlungseingänge, überfällige Rechnungen oder neue Belege per E-Mail.',
          bullets: [
            'Zahlungseingang benachrichtigt',
            'Mahnung fällig',
            'Neue E-Mail-Belege',
            'Steuertermine erinnern',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Laden Sie die App herunter"
      ctaDescription="Verfügbar für iOS und Android. Starten Sie noch heute mit der mobilen Buchhaltung."
    />
  );
}
